const fontFamilies = {
    roboto: ['roboto', 'sans-serif'].join(','),
    industry: ['Industry', 'sans-serif'].join(',')
};

export { fontFamilies };
